<template>
  <div class="login-container">
    <div class="main">
      <div class="dmc">IWRS</div>
      <div class="login-box">
        <div class="box">
          <img
            class="boxImg"
            src="../../assets/login/bgLogo.png"
            width="80%"
            alt="图片"
          />
        </div>
        <div class="box">
          <div class="boxImg" style="width: 80%; height: 60%">
            <div class="title">医兰德中央随机化管理系统</div>
            <el-form
              ref="loginForm"
              :model="loginForm"
              :rules="loginRules"
              class="login-form"
              auto-complete="on"
              label-position="left"
            >
              <el-form-item
                prop="phone"
                style="border: 1px solid #a9a9a9; background-color: #fff"
              >
                <span class="svg-container">
                  <svg-icon icon-class="user" />
                </span>
                <el-input
                  ref="phone"
                  v-model="loginForm.phone"
                  placeholder="请输入手机号或邮箱"
                  name="phone"
                  type="text"
                  tabindex="1"
                  auto-complete="on"
                />
              </el-form-item>

              <el-form-item
                prop="password"
                style="border: 1px solid #a9a9a9; background-color: #fff"
              >
                <span class="svg-container">
                  <svg-icon icon-class="password" />
                </span>
                <el-input
                  :key="passwordType"
                  ref="password"
                  v-model="loginForm.password"
                  :type="passwordType"
                  placeholder="请输入密码"
                  name="password"
                  tabindex="2"
                  auto-complete="on"
                  @keyup.enter.native="handleLogin"
                />
                <span class="show-pwd" @click="showPwd">
                  <svg-icon
                    :icon-class="
                      passwordType === 'password' ? 'eye' : 'eye-open'
                    "
                  />
                </span>
              </el-form-item>

              <div style="text-align: right; margin-bottom: 10px;">
                <el-button type="text" style="color: #666; padding: 0;" @click="goFindPwd">忘记密码</el-button>
              </div>
              <el-button
                :loading="loading"
                type="primary"
                style="width: 100%; margin-bottom: 30px"
                @click.native.prevent="handleLogin"
                >登录</el-button
              >
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { setUserId } from "@/utils/auth";
export default {
  name: "Login",
  data() {
    const validateUsername = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入手机号或邮箱"));
      } else {
        callback();
      }
    };
    const validatePassword = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入密码"));
      } else {
        callback();
      }
    };
    return {
      loginForm: {
        phone: "",
        password: "",
      },
      loginRules: {
        phone: [
          { required: true, trigger: "blur", validator: validateUsername },
        ],
        password: [
          { required: true, trigger: "blur", validator: validatePassword }
        ],
      },
      loading: false,
      passwordType: "password",
      redirect: undefined,
      loginNum: "", // 登陆次数
      userId: "",
    };
  },
  methods: {
    goFindPwd() {
      this.$router.push({ path: "/findPwd" });
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "";
      } else {
        this.passwordType = "password";
      }
      this.$nextTick(() => {
        this.$refs.password.focus();
      });
    },
    handleLogin() {
      let loginObj = JSON.parse(localStorage.getItem("login_account"));
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          //首次登录或者登录同一个账号
          // if (
          //   !loginObj ||
          //   this.loginForm.phone === loginObj.phone ||
          //   this.loginForm.phone === loginObj.email
          // ) {
            this.loading = true;
            this.$store
              .dispatch("user/login", this.loginForm)
              .then((res) => {
                if (res && res.code === 0) {
                  sessionStorage.setItem("iwrs_root", res.data.user.is_manager);
                  sessionStorage.setItem("iwrs_token", res.data.token);
                  sessionStorage.setItem("iwrs_environment", 'UAT');
                  localStorage.setItem(
                    "login_account",
                    JSON.stringify({
                      phone: res.data.user.phone,
                      email: res.data.user.email,
                    })
                  );
                  sessionStorage.setItem(
                    "iwrs_refresh_token",
                    res.data.refresh_token
                  );
                  this.loading = false;
                  sessionStorage.setItem(
                    "iwrs_userForm",
                    JSON.stringify(this.loginForm)
                  );
                  setUserId(res.data.user.id);
                  if (res.data.user.is_manager) {
                    this.$store.commit("user/SET_IS_ADMIN", true);
                  }
                  setTimeout(() => {
                    this.$router.push({ path: "/" });
                  }, 0);
                } else {
                  this.loading = false;
                  this.$message.error(res.msg);
                }
              })
              .catch(() => {
                this.loading = false;
              });
          // } else {
          //   this.$message.error("同一浏览器只能登录一个账号");
          // }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss">
/* 修复input 背景不协调 和光标变色 */
/* Detail see https://github.com/PanJiaChen/vue-element-admin/pull/927 */

$bg: #fff;
$light_gray: #000;
$cursor: #a9a9a9;

@supports (-webkit-mask: none) and (not (cater-color: $cursor)) {
  .login-container .el-input input {
    color: $cursor;
  }
}

/* reset element-ui css */
.login-container {
  .svg-container {
    margin-left: 10px;
  }
  .el-input {
    display: inline-block;
    height: 47px;
    width: 85%;

    input {
      background: transparent;
      border: 0px;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      color: $light_gray;
      height: 47px;
      caret-color: $cursor;

      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px $bg inset !important;
        -webkit-text-fill-color: $cursor !important;
      }
    }
  }

  .el-form-item {
    border: 1px solid rgba(255, 255, 255, 0.1);
    background: rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    color: #454545;
  }
}
</style>

<style lang="scss" scoped>
.login-container {
  width: 100%;
  height: 100%;
  background-image: url("../../assets/login/bg.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.main {
  background-color: #fff;
  width: 70%;
  height: 70%;
  margin: 0 auto;
  border-radius: 8px;
  position: relative;
  top: 50%; /*偏移*/
  transform: translateY(-50%);
}
.dmc {
  text-align: right;
  padding: 10px;
  color: #262626;
  font-size: 18px;
  font-weight: bold;
}
.login-box {
  display: flex;
  width: 100%;
  height: 92%;
}
.box {
  width: 50%;
  height: 100%;
}
.boxImg {
  display: block;
  margin: 0 auto;
  position: relative;
  height: 60%;
  top: 50%; /*偏移*/
  transform: translateY(-50%);
}
.title {
  color: #262626;
  font-weight: bold;
  font-size: 20px;
  text-align: center;
  width: 100%;
}
.login-form {
  position: relative;
  width: 520px;
  max-width: 100%;
  padding: 60px 35px 0;
  margin: 0 auto;
  overflow: hidden;
}
.show-pwd {
  position: absolute;
  right: 10px;
  top: 7px;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
}
</style>
